import { IHoverField } from '@/react/types/components'
import { checkIsSafari } from '@/utils/checkIsSafari'
import { css } from '@emotion/react'
import { createPortal } from 'react-dom'

interface HoverFieldProps {
  hoveredField: IHoverField
}

const HoverFieldPopup = ({ hoveredField }: HoverFieldProps) => {
  const isSafari = checkIsSafari()
  const baseStyle = getBaseStyle(hoveredField, isSafari)

  return createPortal(
    <div css={baseStyle}>{hoveredField?.text}</div>,
    document.body,
  )
}

const getBaseStyle = (hoveredField: IHoverField, isSafari: boolean) =>
  css({
    top: hoveredField.position.top,
    left: hoveredField.position.left,
    zIndex: 1000,
    display: !isSafari ? 'block' : 'none',
    position: 'absolute',
    border: '1px solid #D3D3D3',
    boxShadow: '2px 4px 7px 0px rgba(0, 0, 0, 0.15)',
    background: 'white',
    padding: '4px 11px',
    maxWidth: '400px',
    wordBreak: 'break-word',
  })

export default HoverFieldPopup
